// "16+" keeps reading left to right inside Hebrew text. A Hebrew name
// ("לכל הגילאים") needs no marks — around it they would push whatever follows
// it (" · 4") to the wrong side.
export const ageText = (label) => (!label ? null : /[֐-׿]/.test(label) ? label : `‎${label}‎`);
